<template>
  <div class="logo" :style="style">
    <img :src="image" />
  </div>
</template>

<script>
import image from "../assets/leech.png";

export default {
  props: {
    color: {
      type: String,
      default: "#d05366",
    },
  },
  data() {
    return {
      image: image,
    };
  },
  computed: {
    style() {
      return { backgroundColor: this.color };
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  box-sizing: border-box;
  padding: 5px;

  img {
    width: 40px;
    height: 40px;
  }
}
</style>
